import * as React from 'react'
import * as Styles from "./slider.module.sass"
import Icon from './icon';
import Button from './button'

class Slider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      top: props.startIndex || 0,
      count: 0
    };
    this.next = () => this.setState((state) => {
      let count = React.Children.count(this.props.children)
      return {
        top: (state.top + 1) % count,
        count: count
      }
    });
    this.prev = () => this.setState((state) => {
      let count = React.Children.count(this.props.children)
      return {
        top: (state.top === 0) ? count - 1 : state.top - 1,
        count: count
      }
    });
    this.goto = (index) => this.setState(() => {
      let count = React.Children.count(this.props.children)
      return {
        top: (index < 0) ? 0 : index % count,
        count: count
      }
    });
    this.svgchevron = <svg aria-hidden="true" focusable="false" className="svg-inline--fa fa-square fa-w-14" role="img" viewBox="0 0 8 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" d="M6.35376 0.5H7.2933L1.5285 16.8336L1.46977 17L1.5285 17.1664L7.2933 33.5H6.35376L0.530228 17L6.35376 0.5Z" />
    </svg>
    this.svgtriangle = <svg className={`svg-inline--fa fa-square fa-w-14 ${Styles.triangle}`} aria-hidden="true" focusable="false" role="img" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" strokeWidth="2" d="M1 16V1L16 8.5L1 16Z" />
    </svg>

  }
  render() {
    return React.Children.count(this.props.children) ? (
      <div>
        <div className={`${Styles.wrapper}`} >
          {!this.props.nocontrols ? <>
            <Button onClick={this.prev} className={`button is-ghost ${Styles.leftbutton}`}>{React.cloneElement(this.svgchevron)}<noscript>Previous image</noscript></Button>
            <Button onClick={this.next} className={`button is-ghost ${Styles.rightbutton}`}>{React.cloneElement(this.svgchevron)}<noscript>Next image</noscript></Button>
          </> : <></>}
          {React.Children.map(this.props.children, (child, index) => {
            return React.cloneElement(<div className={`${Styles.slide} ${index === this.state.top ? `${Styles.top}` : ""}`} key={index}>{child}</div>)
          })}
          {!this.props.nocontrols ? <>
            <div className={`${Styles.dotswrapper}`}>
              {React.Children.map(this.props.children, (child, index) => {
                const sharedprops = {
                  key: index,
                  onKeyPress: (e, playable) => this.goto(index, e, child.props.playable),
                  'aria-label': `Image #${index}`,
                  role: "button",
                  'tab-index': 0,
                  className: `${Styles.dotitem} ${index === this.state.top ? `${Styles.active}` : ``}`,
                  onClick: (e, playable) => this.goto(index, e, child.props.playable)
                }
                return child.props.playable !== `true` ? React.cloneElement(
                  <Icon
                    {...sharedprops}
                    icon={[index === this.state.top ? "fas" : "far", "square"]} />
                ) : React.cloneElement(<span {...sharedprops}>{this.svgtriangle}</span>)
              })}
            </div>
          </> : <></>}
        </div>
      </div>
    ) : (<></>);
  }
}

export default Slider
